/**
 * Formats a number to a string with two decimal places
 * Returns "NA" for null, undefined, or NaN values
 *
 * @param value - The number to format
 * @returns The formatted number string or "NA" for invalid values
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return "";
  }
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
